module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card-selected': _vm.selected
    }
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.getHeadIcon(_vm.anchor.logoPic),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.anchor.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.multVoiceAmounts,
      "placement": "bottom"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/icon-tracks-count.png")
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.anchor.tracksCount))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../src/assets/icon-spliter.png")
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.multFansAmounts,
      "placement": "bottom"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/icon-fans-count.png")
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.anchor.fansCount))])], 1), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('span', [_vm._v(_vm._s(_vm.anchor.personDescribe || _vm.$t('word.none')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c376de8!./~/vue-loader/lib/selector.js?type=template&index=0!./views/components/AnchorCard.vue
// module id = 1078
// module chunks = 0